// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

(function () {
  function cssEsc(s) {
    return (window.CSS && CSS.escape)
      ? CSS.escape(s)
      : String(s).replace(/["\\]/g, "\\$&");
  }

  function setLoadingForWrap(wrap, isLoading) {
    if (!wrap) return;
    wrap.setAttribute("aria-busy", isLoading ? "true" : "false");

    wrap.querySelectorAll(".he-qf-btn").forEach((a) => {
      a.style.pointerEvents = isLoading ? "none" : "";
      a.style.opacity = isLoading ? "0.6" : "";
    });
  }

  function setPressed(btn, isPressed) {
    if (!btn) return;
    btn.classList.toggle("he-qf-btn--pressed", isPressed);
  }

  function clearPressed(wrap) {
    (wrap || document).querySelectorAll(".he-qf-btn.he-qf-btn--pressed").forEach((b) => {
      b.classList.remove("he-qf-btn--pressed");
    });
  }

  function markActive(wrap, btn) {
    if (!wrap || !btn) return;
    wrap.querySelectorAll(".he-qf-btn").forEach((b) => {
      b.classList.remove("he-qf-btn--active");
      b.removeAttribute("aria-current");
    });
    btn.classList.add("he-qf-btn--active");
    btn.setAttribute("aria-current", "true");
  }

  function findFilterInput(name, value) {
    const selStrict =
      `input[type="checkbox"][data-filter-item-input][name="${cssEsc(
        name
      )}"][value="${cssEsc(value)}"]`;

    const selLoose =
      `input[type="checkbox"][name="${cssEsc(name)}"][value="${cssEsc(value)}"]`;

    return document.querySelector(selStrict) || document.querySelector(selLoose);
  }

  function findSortRadio(value) {
    const selStrict =
      `input[type="radio"][data-sort-item-input][name="sort_by"][value="${cssEsc(
        value
      )}"]`;

    const selLoose =
      `input[type="radio"][name="sort_by"][value="${cssEsc(value)}"]`;

    return document.querySelector(selStrict) || document.querySelector(selLoose);
  }

  function silentlyUncheckAllValues(name) {
    const selStrict =
      `input[type="checkbox"][data-filter-item-input][name="${cssEsc(name)}"]`;
    const selLoose =
      `input[type="checkbox"][name="${cssEsc(name)}"]`;

    const nodes = document.querySelectorAll(selStrict).length
      ? document.querySelectorAll(selStrict)
      : document.querySelectorAll(selLoose);

    nodes.forEach((i) => {
      i.checked = false;
    });
  }

  function clickNativeControl(input) {
    if (!input) return false;

    const label = input.closest("label");
    if (label) {
      label.click();
      return true;
    }

    input.click();
    return true;
  }

  function warnNotFound(type, name, value, btn) {
    console.warn("[Hello Edie Quick Filters] Native control not found.", {
      type,
      name,
      value,
      href: btn?.href,
      pathname: location.pathname,
    });
  }

  function waitForFilterUpdateDone(timeoutMs = 4000) {
    const resultsEl = document.querySelector("[data-results-count]");
    const activeEl =
      document.querySelector("[data-active-filters]") ||
      document.querySelector(".active-filters");

    let done = false;

    return new Promise((resolve) => {
      const finish = () => {
        if (done) return;
        done = true;
        observer.disconnect();
        clearTimeout(t);
        resolve();
      };

      const observer = new MutationObserver(() => finish());

      if (resultsEl)
        observer.observe(resultsEl, { childList: true, subtree: true, characterData: true });
      if (activeEl)
        observer.observe(activeEl, { childList: true, subtree: true, characterData: true });

      const t = setTimeout(finish, timeoutMs);
    });
  }

  function getGroupsForWrap(wrap) {
    const raw = wrap?.getAttribute("data-qf-groups") || "";
    return raw
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }

  document.addEventListener(
    "click",
    async function (e) {
      const btn = e.target.closest(".he-qf-btn");
      if (!btn) return;

      const wrap = btn.closest(".he-quickfilters");
      if (!wrap) return;

      const clearAll = btn.getAttribute("data-qf-clear") === "true";
      const name = btn.getAttribute("data-filter-name");
      const value = btn.getAttribute("data-filter-value");
      const sortBy = btn.getAttribute("data-sort-by");

      if (!clearAll && !name && !sortBy) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

      clearPressed(wrap);
      setPressed(btn, true);
      markActive(wrap, btn);
      setLoadingForWrap(wrap, true);

      try {
        if (clearAll) {
          const clearLink =
            document.querySelector("[data-clear-all-filters]") ||
            document.querySelector(".active-filters__clear");

          if (clearLink) {
            clearLink.click();
          } else {
            console.warn(
              "[Hello Edie Quick Filters] Clear filters control not found; falling back to navigation.",
              { href: btn.href }
            );
            window.location.href = btn.href;
            return;
          }

          await waitForFilterUpdateDone();
          return;
        }

        // NON-cumulative within this quickfilter bar:
        // Clear only the groups declared on this wrapper.
        const groups = getGroupsForWrap(wrap);
        groups.forEach(silentlyUncheckAllValues);

        if (name && value) {
          const input = findFilterInput(name, value);
          if (!input) {
            warnNotFound("filter", name, value, btn);
            window.location.href = btn.href;
            return;
          }

          if (!clickNativeControl(input)) {
            warnNotFound("filter-click", name, value, btn);
            window.location.href = btn.href;
            return;
          }
        }

        if (sortBy) {
          const radio = findSortRadio(sortBy);
          if (!radio) {
            warnNotFound("sort", "sort_by", sortBy, btn);
            window.location.href = btn.href;
            return;
          }

          if (!clickNativeControl(radio)) {
            warnNotFound("sort-click", "sort_by", sortBy, btn);
            window.location.href = btn.href;
            return;
          }
        }

        await waitForFilterUpdateDone();
      } finally {
        setLoadingForWrap(wrap, false);
        clearPressed(wrap);
      }
    },
    true
  );
})();

(function () {
  function getActiveFiltersRoot() {
    return (
      document.querySelector("[data-active-filters]") ||
      document.querySelector(".active-filters") ||
      null
    );
  }

  function getNativeSelectedFilters() {
    const root = getActiveFiltersRoot();
    const scope = root || document;

    const chips = scope.querySelectorAll(
      'a[data-remove-filter][data-name][data-value], button[data-remove-filter][data-name][data-value]'
    );

    const selected = [];
    chips.forEach((el) => {
      selected.push({
        name: el.getAttribute("data-name"),
        value: el.getAttribute("data-value"),
      });
    });

    return selected;
  }

  function getNativeSort() {
    const checkedStrict = document.querySelector(
      'input[type="radio"][name="sort_by"][data-sort-item-input]:checked'
    );
    if (checkedStrict) return checkedStrict.value;

    const checkedLoose = document.querySelector('input[type="radio"][name="sort_by"]:checked');
    return checkedLoose ? checkedLoose.value : null;
  }

  function clearWrapActive(wrap) {
    wrap.querySelectorAll(".he-qf-btn").forEach((b) => {
      b.classList.remove("he-qf-btn--active");
      b.removeAttribute("aria-current");
    });
  }

  function setWrapActiveByKey(wrap, key) {
    clearWrapActive(wrap);
    if (!key) return;

    const btn = wrap.querySelector(`.he-qf-btn[data-qf-key="${CSS.escape(key)}"]`);
    if (!btn) return;

    btn.classList.add("he-qf-btn--active");
    btn.setAttribute("aria-current", "true");
  }

  // Per-wrap sync: only highlight if exactly one of THAT wrap's options is active.
  function syncOneWrap(wrap) {
    const selected = getNativeSelectedFilters();
    const sortBy = getNativeSort();

    // Build a set of active keys based on the wrap's own buttons
    const activeKeys = [];

    wrap.querySelectorAll(".he-qf-btn[data-qf-key]").forEach((btn) => {
      const key = btn.getAttribute("data-qf-key");
      if (!key || key === "all") return;

      // sort key
      const sort = btn.getAttribute("data-sort-by");
      if (sort && sortBy === sort) {
        activeKeys.push(key);
        return;
      }

      // filter key
      const name = btn.getAttribute("data-filter-name");
      const value = btn.getAttribute("data-filter-value");
      if (name && value) {
        const hit = selected.some((x) => x.name === name && x.value === value);
        if (hit) activeKeys.push(key);
      }
    });

    if (activeKeys.length === 1) {
      setWrapActiveByKey(wrap, activeKeys[0]);
    } else {
      setWrapActiveByKey(wrap, null);
    }
  }

  function syncAllWraps() {
    document.querySelectorAll(".he-quickfilters").forEach(syncOneWrap);
  }

  let syncQueued = false;
  function scheduleSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(() => {
      syncQueued = false;
      syncAllWraps();
    });
  }

  function observeRerenders() {
    const target =
      document.querySelector("#MainContent") ||
      document.querySelector("main") ||
      document.body;

    const observer = new MutationObserver(() => scheduleSync());
    observer.observe(target, { childList: true, subtree: true, characterData: true });

    scheduleSync();
  }

  document.addEventListener(
    "click",
    (e) => {
      const clearBtn = e.target.closest("[data-clear-all-filters], .active-filters__clear");
      if (clearBtn) {
        // Clear all quick highlights immediately, then resync after AJAX
        document.querySelectorAll(".he-quickfilters").forEach((wrap) => setWrapActiveByKey(wrap, null));
        scheduleSync();
        return;
      }

      if (
        e.target.closest("[data-remove-filter]") ||
        e.target.closest('input[name^="filter."]') ||
        e.target.closest('input[name="sort_by"]')
      ) {
        scheduleSync();
      }
    },
    true
  );

  window.addEventListener("popstate", () => scheduleSync());

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeRerenders);
  } else {
    observeRerenders();
  }
})();
